import { InjectionToken } from '@angular/core';

/**
 * Load a css resource into the document head
 *
 * @param document the document
 * @param src resource src
 */
export const loadCssResource = (document, src: string, lazy = false): void => {
    const cssLink: HTMLElement = document.createElement('link');
    /**
     * @SSR: It's best to use the setAttribute when updating DOM elements.
     * SSR didn't know what to do with the 'as' property. Using the method
     * worked
     */
    cssLink.setAttribute('rel', 'stylesheet');
    cssLink.setAttribute('href', src);

    // Lazy load CSS
    if (lazy) {
        // Add noscript tag to load css
        const noscript = document.createElement('noscript');
        const nsCssLink: Element = document.createElement('link');
        nsCssLink.setAttribute('rel', 'stylesheet');
        nsCssLink.setAttribute('href', src);
        noscript.appendChild(nsCssLink);
        document.head.appendChild(noscript);

        // Change the link to preload then alter it to a stylesheet onload
        cssLink.setAttribute('rel', 'preload');
        cssLink.setAttribute('as', 'style');
        cssLink.onload = () => {
            cssLink.onload = null;
            cssLink.setAttribute('rel', 'stylesheet');
        };
    } else {
        const cssLinkPreloader: HTMLElement = document.createElement('link');
        cssLinkPreloader.setAttribute('rel', 'preload');
        cssLinkPreloader.setAttribute('as', 'style');
        cssLinkPreloader.setAttribute('href', src);
        document.head.appendChild(cssLinkPreloader);
    }

    document.head.appendChild(cssLink);
};

export type LoadCssResourceProvider = (document: any, src: string, lazy?: boolean) => void;
export const LOAD_CSS_RESOURCE =
    new InjectionToken('LOAD_CSS_RESOURCE', {
        factory: () => loadCssResource
    });
